import { useCurrentUser } from "./api/userGetters";
import { useTheme } from "./ThemeProvider";
import { useLayoutEffect } from "react";

export const UserThemeSetter = () => {
    const user = useCurrentUser();
    const { setTheme } = useTheme();

    const theme = user.theme;
    useLayoutEffect(() => {
        setTheme(theme);
    }, [theme, setTheme]);

    return <></>;
};
